/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsRestoreAccountConnectivityConfig } from '../models/AwsRestoreAccountConnectivityConfig';
import { GcpRestoreAccountConnectivityConfig } from '../models/GcpRestoreAccountConnectivityConfig';

export class ProviderRestoreAccountConnectivityConfig {
  'aws'?: AwsRestoreAccountConnectivityConfig | null;
  'gcp'?: GcpRestoreAccountConnectivityConfig | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "aws",
      "baseName": "aws",
      "type": "AwsRestoreAccountConnectivityConfig",
      "format": ""
    },
    {
      "name": "gcp",
      "baseName": "gcp",
      "type": "GcpRestoreAccountConnectivityConfig",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ProviderRestoreAccountConnectivityConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

